import api from './api';

export const whatsappApi = {
  getConversations: async () => {
    const response = await api.get('/whatsapp/conversations');
    return response.data;
  },

  createConversation: async (data) => {
    const response = await api.post('/whatsapp/conversations', data);
    return response.data;
  },

  getMessages: async (conversationId) => {
    const response = await api.get(`/whatsapp/conversations/${conversationId}/messages`);
    return response.data;
  },

  sendMessage: async (data) => {
    const isFormData = data instanceof FormData;
    const response = await api.post('/whatsapp/send', data, {
      headers: isFormData ? { 'Content-Type': 'multipart/form-data' } : undefined
    });
    return response.data;
  },

  getTemplates: async () => {
    const response = await api.get('/whatsapp/templates');
    return response.data;
  },

  sendTemplate: async (data) => {
    const response = await api.post('/whatsapp/send-template', data);
    return response.data;
  },

  assignConversation: async (conversationId, assignedTo) => {
    const response = await api.patch(`/whatsapp/conversations/${conversationId}/assign`, { assignedTo });
    return response.data;
  },

  updateConversationStatus: async (conversationId, status) => {
    const response = await api.patch(`/whatsapp/conversations/${conversationId}/status`, { status });
    return response.data;
  }
};
